
import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "components/ui";

const EditorSkeleton = ({ showSwitch = false }) => {
  return (
    <div className="p-5 py-2">
      <div className="mb-2 flex items-center justify-between gap-2.5">
        <Skeleton
          variant="text"
          width={140}
          height={24}
        />

        {showSwitch && (
          <Skeleton
            variant="rounded"
            width={44}
            height={24}
            sx={{ borderRadius: "999px" }}
          />
        )}
      </div>

      <div className="overflow-hidden rounded-lg border">
        {/* ReactQuill toolbar skeleton */}
        <div className="flex items-center gap-3 border-b p-3 overflow-hidden">
          {Array.from({ length: 8 }, (_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              width={20}
              height={20}
              sx={{ flexShrink: 0 }}
            />
          ))}
        </div>

        {/* ReactQuill editor skeleton */}
        <div className="min-h-[180px] space-y-3 p-4">
          <Skeleton variant="text" width="75%" height={22} />
          <Skeleton variant="text" width="50%" height={22} />
          <Skeleton variant="text" width="65%" height={22} />
        </div>
      </div>
    </div>
  );
};

const SignatureSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 lg:gap-7.5 mb-[20px]">
      <div className="xl:col-span-2">
        <Card className="min-w-full">
          <CardContent>
            <div className="grid grid-cols-1 gap-5 lg:gap-7.5">
              {/* User Mail Signature */}
              <Card>
                <CardHeader>
                  <Skeleton
                    variant="text"
                    width={160}
                    height={32}
                  />
                </CardHeader>

                <CardContent className="grid gap-5">
                  <EditorSkeleton />
                </CardContent>
              </Card>

              {/* Web & App Signature */}
              <Card>
                <CardHeader>
                  <Skeleton
                    variant="text"
                    width={190}
                    height={32}
                  />
                </CardHeader>

                <CardContent className="grid gap-5 grid-cols-1 xl:grid-cols-2">
                  {Array.from({ length: 3 }, (_, index) => (
                    <EditorSkeleton
                      key={index}
                      showSwitch
                    />
                  ))}
                </CardContent>
              </Card>
            </div>
          </CardContent>

          <CardFooter className="justify-end">
            <Skeleton
              variant="rounded"
              width={96}
              height={40}
              sx={{ borderRadius: "6px" }}
            />
          </CardFooter>
        </Card>
      </div>
    </div>
  );
});

SignatureSkeleton.displayName = "SignatureSkeleton";

export default SignatureSkeleton;
